import { render, staticRenderFns } from "./ProductoSucursalFiltroCategoria.vue?vue&type=template&id=15d5fede&scoped=true&"
import script from "./ProductoSucursalFiltroCategoria.vue?vue&type=script&lang=js&"
export * from "./ProductoSucursalFiltroCategoria.vue?vue&type=script&lang=js&"
import style0 from "./ProductoSucursalFiltroCategoria.vue?vue&type=style&index=0&id=15d5fede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5fede",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VChip,VMenu})
